import { useState } from "react";
import { Button } from "../../../components/ui/button";
import { IconChevronDown, IconChevronUp } from "../../../components/icons";
import { FieldLabel, TextArea } from "../_components/AdminShell";

interface AiGenerateFieldsPanelProps {
  formName?: string;
  hasExistingFields: boolean;
  isGenerating: boolean;
  error: string | null;
  onGenerate: (prompt: string, mode: "replace" | "append") => void;
}

export function AiGenerateFieldsPanel({
  formName,
  hasExistingFields,
  isGenerating,
  error,
  onGenerate,
}: AiGenerateFieldsPanelProps) {
  const [prompt, setPrompt] = useState("");
  const [mode, setMode] = useState<"replace" | "append">("replace");
  const [open, setOpen] = useState(false);

  const trimmed = prompt.trim();
  const canSubmit = trimmed.length >= 3 && !isGenerating;

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm sm:p-4">
      <button
        type="button"
        className="flex w-full items-center gap-1.5 text-left"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <h2 className="font-onest text-sm font-semibold text-ink">
          AI-генерация полей
        </h2>
        {open ? (
          <IconChevronUp size={16} className="shrink-0 text-slate-500" />
        ) : (
          <IconChevronDown size={16} className="shrink-0 text-slate-500" />
        )}
      </button>

      {open ? (
        <div className="mt-3 space-y-3">
          <div>
            <FieldLabel size="compact">Описание</FieldLabel>
            <TextArea
              size="compact"
              value={prompt}
              rows={3}
              placeholder={
                formName?.trim()
                  ? `Например: форма «${formName.trim()}» с ФИО, телефоном и городом`
                  : "Например: сделай форму с полями имя, фамилия, телефон"
              }
              onChange={setPrompt}
            />
            <p className="mt-1 font-onest text-[11px] text-slate-500">
              От 3 символов. DeepSeek подберёт типы полей.
            </p>
          </div>

          {hasExistingFields ? (
            <div className="flex flex-wrap gap-3">
              <label className="inline-flex items-center gap-1.5 font-onest text-xs text-slate-700">
                <input
                  type="radio"
                  name="ai-generate-mode"
                  checked={mode === "replace"}
                  onChange={() => setMode("replace")}
                  className="text-brand-500 focus:ring-brand-500/30"
                />
                Заменить поля
              </label>
              <label className="inline-flex items-center gap-1.5 font-onest text-xs text-slate-700">
                <input
                  type="radio"
                  name="ai-generate-mode"
                  checked={mode === "append"}
                  onChange={() => setMode("append")}
                  className="text-brand-500 focus:ring-brand-500/30"
                />
                Добавить к существующим
              </label>
            </div>
          ) : null}

          {error ? (
            <div
              className="rounded-lg border border-red-200 bg-red-50 px-3 py-2"
              role="alert"
            >
              <p className="font-onest text-xs text-red-700">{error}</p>
            </div>
          ) : null}

          <Button
            disabled={!canSubmit}
            className="!px-3 !py-1.5 text-xs"
            onClick={() => onGenerate(trimmed, mode)}
          >
            {isGenerating ? "Генерация…" : "Сгенерировать"}
          </Button>
        </div>
      ) : null}
    </section>
  );
}
